import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { AuthService } from '../../../../../services/auth.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ServicosComponent } from '../servicos/servicos.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service';
import { Router } from '@angular/router';
import { DeviceDetectionService } from '../../../../../shared/services/device-detection.service';
import { formularioService } from '../../../../colaborador/services/formulario.service';

@Component({
  selector: 'app-analise',
  // Reuse the servicos template and styles so the Analise page keeps the same layout
  standalone: false,
  templateUrl: '../analise/analise.component.html',
  styleUrls: ['../analise/analise.component.css']
})
export class AnaliseComponent extends ServicosComponent implements OnInit {
  constructor(
    usuarioService: UsuarioService,
    servicoService: ServicoService,
    spinner: NgxSpinnerService,
    cdr: ChangeDetectorRef,
    formularioService: formularioService,
    router: Router,
    ngZone: NgZone,
    deviceService: DeviceDetectionService,
    authService: AuthService
  ) {
    // Pass dependencies to the parent (ServicosComponent)
    super(usuarioService, servicoService, spinner, cdr, formularioService, authService, router, ngZone, deviceService);
  }

  filtroDataAnaliseInicio?: string;
  filtroDataAnaliseFim?: string;

  // Antes de inicializar o pai, definimos o filtro para trazer somente os em análise
  override ngOnInit(): void {
    this.filtroStatus = 'Analisando';
    // Caso necessário, podemos ajustar outros filtros padrões aqui
    super.ngOnInit();
    // Garantir que os filtros de período comecem vazios após a inicialização do pai
    this.filtroDataInicio = '';
    this.filtroDataFim = '';
    this.filtroDataAnaliseInicio = undefined;
    this.filtroDataAnaliseFim = undefined;
  }

  override aplicarFiltro(): void {
    // reuse spinner / cdr from parent
  (this as any).spinner.show();
    this.erro = null;
    this.showFiltros = false;

    const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
    const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;

    const status = this.filtroStatus || '';

  (this as any).servicoService.obterTodos(
      dataInicio,
      dataFim,
      this.paginaAtual,
      this.tamanhoPagina,
      status,
      this.filtroNomeConsumidor,
      this.filtroCpf,
      this.filtroCnpj,
      this.filtroMatricula,
      this.filtroCep,
      this.filtroLogradouro,
      this.filtroBairro,
      this.filtroCidade,
      this.filtroEstado,
      this.filtroNumero,
      undefined,
      undefined
    ).subscribe({
      next: (response: any) => {

        (this as any).processarDadosPaginados(response);
        (this as any).atualizarInformacoesPaginacao(response);
        (this as any).aplicarFiltrosLocais();
        if (this.filtroDataAnaliseInicio || this.filtroDataAnaliseFim) {
          const inicio = this.filtroDataAnaliseInicio ? new Date(this.filtroDataAnaliseInicio + 'T00:00:00') : null;
          const fim = this.filtroDataAnaliseFim ? new Date(this.filtroDataAnaliseFim + 'T23:59:59') : null;
          this.servicosFiltrados = this.servicosFiltrados.filter(servico => {
            const dataAnalise = this.getDataAnalise(servico);
            if (!dataAnalise) return true;
            const date = new Date(dataAnalise);
            if (inicio && date < inicio) return false;
            if (fim && date > fim) return false;
            return true;
          });
        }
  (this as any).spinner.hide();
      },
  error: (err: any) => {
        this.servicos = [];
        this.servicosFiltrados = [];
        this.erro = 'Erro ao buscar registros.';
  (this as any).spinner.hide();
      }
    });
  }

  // isSuperAdministrador provided by base class

  // Altera o status de um registro de 'Analisando' para 'Pendente'
  alterarStatusParaPendente(registro: any): void {
    if (!registro) return;

    Swal.fire({
      title: 'Confirmar cancelamento',
      text: 'Deseja cancelar essa analise?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, cancelar!',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (!result.isConfirmed) return;

      (this as any).spinner.show();

      // Determina se é cadastro ou recadastro
      const isRecadastro = registro.tipoServico === 'recadastro';
      const id = isRecadastro ? (registro.recadastroId || registro.id) : (registro.cadastroId || registro.id);

      // Tenta obter o usuarioId do AuthService (se disponível)
      let usuarioId: string | undefined = undefined;
      try {
        const usuario = this.authService.getUsuario();
        usuarioId = usuario?.usuarioId || usuario?.id || (this.authService.usuarioId || undefined);
      } catch (e) {
        usuarioId = this.authService.usuarioId || undefined;
      }

      const chamada = isRecadastro
        ? (this as any).servicoService.atualizarStatusRecadastro(id, 'Pendente', undefined, usuarioId)
        : (this as any).servicoService.atualizarStatusCadastro(id, 'Pendente', undefined, usuarioId);

      chamada.subscribe({
        next: () => {
            // Limpa a chave de análise atual do localStorage (quando o usuário cancela a análise)
            try { localStorage.removeItem('servicoAnalise'); } catch (e) {}

            (this as any).aplicarFiltro();
          (this as any).spinner.hide();
          Swal.fire({
            title: 'Sucesso',
            text: 'Analise cancelada',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false,
            toast: true,
            position: 'top-end'
          });
        },
        error: (err: any) => {
          console.error('Erro ao alterar status:', err);
          (this as any).spinner.hide();
          Swal.fire({
            title: 'Erro',
            text: 'Erro ao alterar status do registro.',
            icon: 'error'
          });
        }
      });
    });
  }
}
